import { type FC } from 'react'
import classNames from 'classnames'

interface ChangeChipProps {
  delta: number
}

export const ChangeChip: FC<ChangeChipProps> = ({ delta }) => (
  <span
    className={classNames('insights-trend-badge', {
      'insights-trend-badge--up': delta > 0,
      'insights-trend-badge--down': delta < 0,
      'insights-trend-badge--neutral': delta === 0,
    })}
  >
    {delta > 0 ? `+${delta}` : delta < 0 ? `−${Math.abs(delta)}` : '0'}
  </span>
)
